import React from "react";
import styled from "styled-components";
import { musics, sports } from "../../Layouts/Header";
import { UIList } from "../../UI/List";
import { NumberText } from "../group/Introduce";
import { RuleSection } from "./RuleSection";

const parts = [
  "Người tham gia đã có Chứng minh nhân dân hoặc Căn cước công dân hợp lệ để nhận giải thưởng nếu là người thắng giải.",
  "Người tham gia cần phải có tài khoản thanh toán (sử dụng ví điện tử Momo cho năm 2023) đăng ký đầy đủ thông tin cá nhân (có số điện thoại và địa chỉ email hợp lệ).",
];

export const RightSection = () => {
  return (
    <Styles>
      <h2 className="title" id="rule-title-1" style={{ paddingTop: "42px" }}>
        GIỚI THIỆU
      </h2>
      <p>
        Giải Âm nhạc Cống hiến do báo Thể thao và Văn hóa/TTXVN khởi xướng và tổ
        chức đã diễn ra từ năm 2005 với sự tham gia bầu chọn của báo giới toàn
        quốc. Trải qua 16 lần trao giải, năm 2023, báo Thể thao và Văn hóa quyết
        định mở rộng Giải Âm nhạc Cống hiến thành Giải Cống hiến nhằm vinh danh
        các sản phẩm, nhân vật, sự kiện trên cả hai lĩnh vực âm nhạc và thể
        thao; đồng thời thay đổi phương thức bầu chọn, nhằm thu hút được đa dạng
        hơn những ý kiến từ công chúng, nhà chuyên môn.
      </p>
      <p style={{ paddingTop: "20px" }}>
        Hoạt động bình chọn Giải thưởng Cống hiến 2023 của khán giả sẽ diễn ra
        từ 15h30 ngày 04/01/2023 đến đêm Trao giải, cụ thể như sau:
      </p>
      <h2>ĐỀ CỬ ĐƯỢC BÌNH CHỌN NHIỀU NHẤT</h2>
      <p>
        Đề cử trong các hạng mục thuộc lĩnh vực Âm nhạc có điểm bình chọn cao
        nhất trong vòng Đề cử trên website https://giaithuongconghien.bvote.vn
        sẽ được đặc cách vào thẳng Top 5 trong hạng mục tương ứng của Giải
        thưởng Cống hiến 2023.
      </p>
      <h2 id="rule-title-2">ĐỐI TƯỢNG THAM GIA</h2>
      <UIList items={parts} className="parts">
        {(item, ind) => {
          return (
            <div className="part-item">
              <NumberText className="part-number">0{ind + 1}</NumberText>
              <GradientText className="part-name">
                Điều kiện {ind + 1}
              </GradientText>
              <p>{item}</p>
            </div>
          );
        }}
      </UIList>
      <h2 id="rule-title-3">HẠNG MỤC BÌNH CHỌN</h2>
      <p>Các hạng mục áp dụng bình chọn từ khán giả và Hội đồng bình chọn</p>
      <div className="card">
        <div className="card-title">LĨNH VỰC ÂM NHẠC</div>
        <UIList items={musics} className="card-content">
          {(item) => {
            return <img src={item.image} />;
          }}
        </UIList>
      </div>
      <div className="card">
        <div className="card-title sport">LĨNH VỰC THỂ THAO</div>
        <UIList items={sports} className="card-content">
          {(item) => {
            return <img src={item.image} />;
          }}
        </UIList>
      </div>
      <RuleSection />
    </Styles>
  );
};

export const GradientText = styled.div`
  background: -webkit-linear-gradient(right, #ff8a5a, #a15bff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  width: fit-content;
  font-weight: 700;
`;

const Styles = styled.div`
  margin-left: 31px;

  .title {
    margin-top: 0;
  }
  h2 {
    font-size: 24px;
    font-weight: 700;
    padding: 60px 0 20px;
    margin: 0;
  }

  .parts {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
  }

  .part-item {
    padding: 12px;
    background: linear-gradient(
      94.08deg,
      rgba(161, 91, 255, 0.2) 0%,
      rgba(255, 138, 90, 0.2) 100%
    );
    border-radius: 12px;

    .part-number {
      font-size: 48px;
      color: #30234b;
    }
    .part-name {
      font-size: 18px;
      font-weight: 700;
      margin-top: -8px;
    }

    p {
      margin: 20px 0 0;
    }
  }

  .card {
    padding: 20px 105px 40px;
    border-radius: 16px;
    background: #191d2e;
    margin: 20px 0 30px;
  }

  .card-title {
    font-size: 20px;
    font-weight: 700;
    color: #ffa756;
    margin: 0 0 12px;
    text-align: center;

    &.sport {
      color: #d4ef85;
    }
  }

  .card-content {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 30px;
    > * {
      width: 30%;
      border-radius: 8px;
    }
  }

  @media only screen and (max-width: 1199px) {
    .card {
      padding: 20px 20px 40px;
    }
    .card-content {
      > * {
        width: 29%;
      }
    }
  }

  @media only screen and (max-width: 991px) {
    margin-left: 0;
  }

  @media only screen and (max-width: 767px) {
    .parts {
      grid-template-columns: 1fr;
    }
  }

  @media only screen and (max-width: 480px) {
    .card-content {
      > * {
        width: 100%;
      }
    }
  }
`;
